import { useMemo } from 'react';
import { usePermissionsValidator, useUserData } from 'b2b-apps/shop/context/hooks';
import { useActiveLanguage } from 'b2b-apps/shop/i18n/hooks';
import { AccessCallbackDataType } from 'b2b-apps/shop/routes/components/Router';

type UseAccessCallbackDataReturnType = AccessCallbackDataType;

const useAccessCallbackData = (): UseAccessCallbackDataReturnType => {
  const permissionsValidator = usePermissionsValidator();
  const { isLoggedIn, isBlocked } = useUserData();
  const activeLanguage = useActiveLanguage();

  const accessCallbackData: AccessCallbackDataType = useMemo(
    () => ({
      activeLanguage,
      isLoggedIn,
      isBlocked,
      permissionsValidator,
    }),
    [activeLanguage, isLoggedIn, isBlocked, permissionsValidator],
  );

  return accessCallbackData;
};

export type { UseAccessCallbackDataReturnType };
export { useAccessCallbackData };
